import React from "react";
import type { SolverStatusBarProps } from "./SolverStatusBar.types";

const formatNumber = (n: number) => new Intl.NumberFormat("fr-CA", { maximumFractionDigits: 0 }).format(n);

const SolverStatusBar: React.FC<SolverStatusBarProps> = ({
                                                             wgLabel,
                                                             assigned,
                                                             total,
                                                             globalAssigned,
                                                             globalTotal,
                                                             gain,
                                                             scoreHard,
                                                             scoreSoft,
                                                         }) => {
    let gainText: string | null = null;
    if (gain) {
        const quarts = Math.max(0, gain.quarts);
        const hard = Math.max(0, gain.hard);
        const soft = Math.max(0, gain.soft);
        gainText = `+${formatNumber(quarts)} ${quarts === 1 ? "quart" : "quarts"} + ${formatNumber(hard)} | ${formatNumber(soft)} points`;
    }

    const hasScore = scoreHard != null && scoreSoft != null;

    return (
        <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
            <span className="font-bold">
                {wgLabel ? `${wgLabel} | ` : ""}
                <span title="Quarts attribués dans la portée courante (période et phase)" className="tabular-nums">
                    <span className="sr-only">Dans la portée courante : </span>
                    <span className="text-green-700">{formatNumber(assigned)}</span> / {formatNumber(total)} quarts phase
                </span>
                {" | "}
                <span title="Quarts attribués sur l'ensemble de l'horaire" className="tabular-nums">
                    <span className="sr-only">Sur l'ensemble de l'horaire : </span>
                    {formatNumber(globalAssigned)} / {formatNumber(globalTotal)} quarts total
                </span>
            </span>

            {gainText && (
                <span
                    title="Gain depuis le point le plus bas de l'optimisation (obligatoire | qualité)"
                    className="motion-safe:animate-in motion-safe:fade-in motion-safe:duration-200 font-normal text-green-700">
                    ({gainText})
                </span>
            )}

            {hasScore && (
                <span className="ml-auto font-normal text-muted-foreground tabular-nums">
                    score : {formatNumber(scoreHard)} / {formatNumber(scoreSoft)}
                </span>
            )}
        </div>
    );
};

export default SolverStatusBar;
